import styled from '@emotion/styled';

export const Divider = styled('div')`
  width: 100%;
  background-color: #e8e8e8;
  height: 0.05rem;
`;
